export default "__VITE_ASSET__33e7df5d__"